import React, { useRef } from 'react';

import BlockContent from '@sanity/block-content-to-react';
import richText from '../serializers/richText';
import useIntersection from 'buena-suerte/lib/hooks/useIntersection';
import classNames from 'classnames';

export default ({ title, description }) => (
  <section className="spotlight__body p2 pt10--lg pb10--lg bb--dark-brown">
    <section className="page-richtext spotlight__body-text">
      <h1 className="serif--lg serif--xl--lg pb2 pb5--lg">{title}</h1>
      <div className="sans--sm sans--md--md rich-text">
        <BlockContent blocks={description} serializers={richText} />
      </div>
    </section>
  </section>
);

